<template>
  <div>
    <v-card
      class="rounded-xl mt-5 px-3 py-2 organization-card-hover"
      :key="'organization-' + organization._id"
      elevation="0"
      style="border: 1px solid #EBEBEB; transition: all 0.3s ease; cursor: pointer;"
      @click="navigateToOrganizationProfilePage(organization._id)"
    >
      <v-row align="center">
        <v-col cols="auto" md="auto">
          <div class="ps-3" style="width: 72px">
            <v-img
              class="rounded-lg"
              height="60"
              max-width="60"
              :src="organization.logo ? getImage(organization.logo) : null"
              lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
              cover
            />
          </div>
        </v-col>

        <v-col cols="auto" md="auto">
          <div style="width: 100px">
            <span class="text-start font-weight-medium subtitle-1 textLight--text text-ellipse-2">
              {{ organization.UID }}
            </span>
          </div>
        </v-col>

        <v-col cols md>
          <div>
            <span class="text-start font-weight-medium subtitle-1 textLight--text text-ellipse-2">
              {{ getLocalisedValue(organization.name) }}
            </span>
          </div>
        </v-col>

        <v-col cols="12" md="2">
          <div>
            <span class="d-block text-center subtitle-1 textLight--text">
              {{ organization.totalEmployees }}
            </span>
          </div>
        </v-col>

        <v-col cols="12" md="3" lg="3">
          <div class="d-flex justify-end align-center pe-md-3" style="gap: 12px;" v-on:click.stop>
            <template v-if="havePermissionUpdateOrganization">
              <v-btn
                icon
                small
                color="primary"
                class="rounded-lg bg-primaryLight"
                @click.stop="$emit('editOrganization', organization)"
              >
                <v-icon size="18">mdi-pencil-outline</v-icon>
              </v-btn>
            </template>

            <template v-if="havePermissionEnableDisableOrganization || havePermissionUpdateOrganization">
              <v-switch
                flat
                dense
                hide-details
                inset
                color="success"
                v-model="organization.isActive"
                class="ma-0 pt-0"
                :loading="statusUpdateLoading"
                @click.stop
                @change="value => updateOrDelete(value ? 'enable' : 'disable')"
              ></v-switch>
            </template>

            <template v-if="havePermissionDeleteOrganization">
              <v-btn
                icon
                small
                color="error"
                class="rounded-lg bg-errorLight"
                @click.stop="updateOrDelete('delete')"
              >
                <v-icon size="18">mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { createOrUpdateOrganization } from "../methods/createOrUpdateOrganization";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  data() {
    return {
      statusUpdateLoading: false,
    };
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  computed: {
    havePermissionUpdateOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionEnableDisableOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["ENABLE_DISABLE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    navigateToOrganizationProfilePage(organizationId) {
      if (organizationId) {
        this.$router.push({
          name: "OrganizationProfile",
          params: { organizationId },
        });
      }
    },
    async updateOrDelete(val) {
      if (val) {
        this.statusUpdateLoading = true;
        if (val === "enable") {
          let response = await createOrUpdateOrganization({
            _id: this.organization._id,
            isActive: true,
          });
          if (response) {
            this.statusUpdateLoading = false;
            if (response.error) {
              this.organization.isActive = false;
              this.$emit("updateErr");
            }
          }
        } else if (val === "disable") {
          let response = await createOrUpdateOrganization({
            _id: this.organization._id,
            isActive: false,
          });
          if (response) {
            this.statusUpdateLoading = false;
            if (response.error) {
              this.organization.isActive = true;
              this.$emit("updateErr");
            }
          }
        } else if (val === "delete") {
          this.$emit("deleteOrganization", this.organization._id);
          this.statusUpdateLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.organization-card-hover:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
  border-color: transparent !important;
}
.bg-primaryLight {
  background-color: #F5F1FF !important;
}
.bg-errorLight {
  background-color: #FFF0F0 !important;
}
</style>
